// extracted by mini-css-extract-plugin
module.exports = {"agenda":"Agenda_agenda__1rPJV"};